import { Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

export default function Unauthorized() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  async function handleSignOut() {
    await logout();
    navigate("/");
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full text-center space-y-6">
        {/* Lock icon */}
        <div className="flex justify-center">
          <div className="h-20 w-20 rounded-full bg-red-100 flex items-center justify-center">
            <Lock className="h-10 w-10 text-red-600" aria-hidden="true" />
          </div>
        </div>

        {/* Heading */}
        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-gray-900">Access Restricted</h1>
          <p className="text-sm text-gray-500 leading-relaxed">
            You don&apos;t have permission to access the Admin Panel. Only system
            administrators can access this area.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button
            variant="default"
            onClick={() => navigate("/dashboard")}
            className="w-full sm:w-auto"
          >
            Go to Dashboard
          </Button>
          <Button
            variant="outline"
            onClick={handleSignOut}
            className="w-full sm:w-auto"
          >
            Sign Out
          </Button>
        </div>

        <p className="text-xs text-gray-400">
          If you believe this is an error, please contact{" "}
          <a
            href="mailto:info@stratakey.ca"
            className="underline text-gray-500 hover:text-gray-700"
          >
            info@stratakey.ca
          </a>
          .
        </p>
      </div>
    </div>
  );
}
